import { gql } from "@apollo/client"

export const GET_BLOCK_ASSESSMENT_RECOVERY_CAPITAL = gql`
  query RecoveryCapital($staff_id: String!, $participant_membership_id: ID) {
    recoveryCapital: getSpecificBlocksByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["session", "session__assessment_recovery_capital"]
    ) {
      data
    }
    templateNames: templates(type: "system", staff_id: $staff_id) {
      template_name
      template_title
    }
  }
`
